import { useState, useEffect } from "react";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import css from "./AddJob.module.css";

import Button from "../../../../Components/Button/Button";
import Svg from "../../../../Components/Svg/Svg";
import SvgOptions from "../../../../Components/Svg/SvgOptions";
import Form from "../../../../Components/Form/Form";
import AddJobFormOptions from "./AddJobFormOptions";
import { Get, Post, Put } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import Utils from "../../../../Services/Utills";
import { toast } from "react-toastify";
import Expandable from "../../../../Components/Expandable/Expandable";
import AddSalesEquipment from "../../../../Components/AddEquipment/AddEnterpriseSalesEquipment";

const AddJob = () => {
	const [options, setOptions] = useState(AddJobFormOptions);
	const [expand, setExpand] = useState(true);
	const [equipment, setEquipment] = useState([]);
	const [searchParams] = useSearchParams();
	const jobId = searchParams.get("jobId");
	const nav = useNavigate();

	useEffect(() => {
		if (jobId) {
			Get(Url.sales.getEnterpriseInitial(jobId))
				.then((resp) => {
					if (!resp) return;
					console.log(resp);

					const op = { ...options, Fields: [...options.Fields] };

					const updatedFields = options.Fields.map((fld) => {
						if (fld.name === "company") {
							return {
								...fld,
								value: resp.company
									? { id: resp.company.id, name: resp.company.name }
									: null,
							};
						}

						if (fld.name === "contact") {
							return {
								...fld,
								value: resp.contact
									? { id: resp.contact.id, name: resp.contact.name }
									: null,
							};
						}

						if (fld.name === "email") {
							return {
								...fld,
								value: resp.contact?.email || "",
							};
						}

						return fld;
					});

					setOptions((prev) => ({ ...prev, Fields: updatedFields }));

					if (resp.equipment && resp.equipment.length > 0) {
						setEquipment(
							resp.equipment.map((eq) => ({
								equipment: eq.equipment,
								template: op.Fields.find((fld) => fld.name === "template")
									.value,
							}))
						);
						setExpand(false);
					}
				})
				.catch((err) => {
					console.error("Failed to fetch job details", err);
				});
		}
	}, [jobId]);

	const onSubmit = () => {
		const dt = Utils.FormObject(options);

		if (equipment.length === 0) {
			toast("Kindly add one or more equipment and service");
			return null;
		}

		// ✅ Assign equipment without default service
		dt.equipment = equipment.map((eq) => ({
			...eq,
		}));

		// ✅ Add `self` flag if any equipment has surveyType: "self"
		const hasSelfSurvey = equipment.some((eq) => eq.surveyType === "self");
		dt.selfSurvey = hasSelfSurvey ? true : false;

		// ✅ Add document reference
		const templateField = options.Fields.find((fld) => fld.name === "template");
		dt.doc_id = templateField?.value?.doc_id || null;
		delete dt.template;

		const url = Url.sales.enterpriseInit;
		const successMsg = jobId ? "Job Updated" : "Job Initiated";
		console.log(dt);
		

		const request = jobId ? Put(url, { ...dt, id: jobId }) : Post(url, dt);

		request
			.then((resp) => {
				toast(successMsg);
				if (jobId) {
					nav(`../../EnterpriseJobs/${resp.id}`, { state: { init: resp } });
				} else {
					nav("../");
				}
			})
			.catch((err) => {
				console.log("couldn't save", err);
				toast.error("Failed to save job");
			});
	};

	const companyChange = (e) => {
		if (typeof e === "object" && e != null) {
			const op = { ...options };
			Get(Url.contact(e.id, "e"))
				.then((resp) => {
					op.Fields.find((fld) => fld.name === "contact").options = resp;
					setOptions(op);
				})
				.catch(console.error);
		}
	};

	const countryChange = (e) => {
		if (typeof e === "object" && e != null) {
			Get(Url.contract.getEnterpriseContractByCountry(e.id))
				.then((resp) => {
					const op = { ...options };
					const templateField = op.Fields.find(
						(fld) => fld.name === "template"
					);
					if (templateField) templateField.options = resp;
					setOptions(op);
				})
				.catch((err) => {
					console.log(err);
					const op = { ...options };
					const templateField = op.Fields.find(
						(fld) => fld.name === "template"
					);
					if (templateField) templateField.options = [];
					setOptions(op);
					toast.error("No provision templates found for the selected country.");
				});
		}
	};

	const templateChange = (e) => {
		if (typeof e === "object" && e != null) {
			Get(Url.contract.get(e.id))
				.then((resp) => {
					const op = { ...options };
					const templateField = op.Fields.find(
						(fld) => fld.name === "template"
					);
					if (templateField) {
						templateField.value = {
							id: e.id,
							name: e.name,
							doc_id: resp.doc_id,
						};
					}
					setOptions(op);
				})
				.catch((err) => {
					console.log(err);
					toast.error(
						"Failed to fetch document details for the selected template."
					);
				});
		}
	};

	const contactChange = (e) => {
		setOptions((prev) => {
			const updatedFields = prev.Fields.map((fld) =>
				fld.name === "email" ? { ...fld, value: e?.email || "" } : fld
			);
			return { ...prev, Fields: updatedFields };
		});
	};

	options.Fields.find((fld) => fld.name === "contact").onSelected =
		contactChange;
	options.Fields.find((fld) => fld.name === "country").onSelected =
		countryChange;
	options.Fields.find((fld) => fld.name === "company").onSelected =
		companyChange;
	options.Fields.find((fld) => fld.name === "template").onSelected =
		templateChange;

	// ✅ Equipment handler without default "Installation"
	const handleAddService = (e) => {
		const newEquipment = { ...Utils.FormObject(e) };
		const updatedList = [...equipment, newEquipment];

		setEquipment(updatedList);
		setExpand(false);

		console.log("New equipment added:", newEquipment);
		console.log("Updated equipment list:", updatedList);
	};

	const onDelete = (index) => {
		equipment.splice(index, 1);
		setEquipment([...equipment]);
	};

	return (
		<div className={css.AddJob}>
			<div className={css.Top}>
				<NavLink to=".." style={{ textDecoration: "none" }}>
					<div className={css.BackBox}>
						<Svg>{SvgOptions.BackArrow}</Svg>
						<span>Back</span>
					</div>
				</NavLink>

				<div>
					<Button onClick={onSubmit} className="Btn-Mid Active">
						Save
					</Button>
				</div>
			</div>

			<hr />

			<div className={css.Body}>
				<div className={css.row}>
					<h1 className={css.Title}>
						{jobId ? "Continue Job" : "Initiate Job"}
					</h1>
					<div className={css.Head}>
						<Button
							onClick={() => setExpand(!expand)}
							className="Btn-Mid Active"
							icon={SvgOptions.Add}
						>
							Add Equipment
						</Button>
					</div>
				</div>

				<div className={css.modalCont}>
					<div className={`${css.modal} ${expand ? css.visible : css.hidden}`}>
						<Expandable expand={expand} height={420}>
							<AddSalesEquipment onSubmit={handleAddService} />
						</Expandable>
					</div>
				</div>

				<Form onSubmit={onSubmit}>{options}</Form>

				<div className={css.EquipmentList}>
					{equipment.map((eq, index) => (
						<EquipmentView key={index} index={index} onDelete={onDelete}>
							{eq}
						</EquipmentView>
					))}
				</div>
			</div>
		</div>
	);
};

const EquipmentView = ({ children, onDelete, index }) => {
	const { equipment, template } = children;

	return (
		<div className={css.EquipmentView}>
			<div>
				<div>{equipment}</div>
				<div onClick={() => onDelete(index)} className={css.DeleteIcon}>
					<Svg>{SvgOptions.Delete}</Svg>
				</div>
			</div>

			<div style={{ display: "flex", justifyContent: "space-between" }}>
				<div>{template?.name}</div>
			</div>
		</div>
	);
};

export default AddJob;
